import * as React from "react";
import type { SVGProps } from "react";
const SvgDataset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 21"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1 16.35V4.837m15.35.001V16.35"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M8.675 8.675c4.24 0 7.676-1.718 7.676-3.837S12.914 1 8.675 1C4.437 1 1 2.718 1 4.838s3.437 3.837 7.675 3.837Zm7.675 1.919c0 2.12-3.436 3.837-7.675 3.837S1 12.713 1 10.594m15.35 5.756c0 2.12-3.436 3.838-7.675 3.838S1 18.47 1 16.35"
    />
  </svg>
);
export default SvgDataset;
